var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import { cx, css } from 'emotion';
export default (function (_a) {
  var className = _a.className,
      height = _a.height,
      width = _a.width,
      size = _a.size,
      rotation = _a.rotation,
      fill = _a.fill;
  return cx(css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      display: inline-block;\n      height: ", ";\n      width: ", ";\n      transform: rotate(", "deg);\n      fill: ", ";\n    "], ["\n      display: inline-block;\n      height: ", ";\n      width: ", ";\n      transform: rotate(", "deg);\n      fill: ", ";\n    "])), height || size, width || size, rotation, fill), className);
});
var templateObject_1;